import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';
import { PaginationUtil } from 'ng-jhipster';

import { EventComponent } from './event.component';
import { EventDetailComponent } from './event-detail.component';
import { EventDetailNoAuthComponent } from './event-detail-no-auth.component';
import { EventPopupComponent } from './event-dialog.component';
import { EventDeleteDialogComponent, EventDeletePopupComponent } from './event-delete-dialog.component';

@Injectable()
export class EventResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'begining, desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}


export const eventRoute: Routes = [
    {
        path: 'event',
        component: EventComponent,
        resolve: {
            'pagingParams': EventResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.event.home.title'
        }
    },
    {
        path: 'event/:id',
        component: EventDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.event.home.title'
        }
    },
    {
        path: 'event-public/:id',
        component: EventDetailNoAuthComponent,
        data: {
            pageTitle: 'jYoguiApp.event.home.title'
        }
    }
];

export const eventPopupRoute: Routes = [
    {
        path: 'event-new',
        component: EventPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.event.home.title'
        },
        outlet: 'popup'
   },
   {
        path: 'event/:id/edit',
        component: EventPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.event.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'event/:id/delete',
        component: EventDeletePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.event.home.title'
        },
        outlet: 'popup'
    },
];





// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event.route.ts